import { Nullable } from "../types/Nullable";

export function isValidRouterString(arg?: Nullable<unknown>): arg is string {
  return typeof arg === "string" && arg.length > 0;
}
